<script setup lang="ts">
  import { onMounted, computed } from 'vue';
  import { DocumentPlusIcon } from '@heroicons/vue/20/solid';
  import { secondsToHoursAndMinutes } from '@/utils/item-printer.ts';

  const props = defineProps<{
    attendanceId: number;
    applicationType: string;
    workTime: number;
    approvalWorkTime: number;
  }>();

  const emit = defineEmits<{
    (
      event: 'request-approval',
      applicationType: string,
      attendanceId: number
    ): void;
  }>();

  function handleApprovalRequest() {
    emit('request-approval', props.applicationType, props.attendanceId);
  }

  const neededToApproval = computed(() => {
    // 60초 이상 차이가 나면 승인 요청 버튼이 보이도록
    return props.workTime - props.approvalWorkTime > 60;
  });

  onMounted(() => {
    // console.log('ApprovalButton props: ', props);
  });
</script>

<template>
  <div>
    {{ secondsToHoursAndMinutes(props.workTime) }} /
    {{ secondsToHoursAndMinutes(props.approvalWorkTime) }}
    <button
      v-if="neededToApproval"
      class="align-middle btn btn-secondary btn-xs btn-circle btn-ghost text-secondary"
      @click="handleApprovalRequest()">
      <DocumentPlusIcon class="w-6 h-6" />
    </button>
  </div>
</template>
